export enum AuMeasurementStatuses {
	GOOD = 'GOOD',
	NORMAL = 'NORMAL',
	WARNING = 'WARNING',
	OK = 'OK',
	BAD = 'BAD',
	POOR = 'POOR',
	CRITICAL = 'CRITICAL',
	NoData = 'no_data',
}

export const AuMeasurementStatusesTranslationKeys: Record<AuMeasurementStatuses, string> =
	{
		[AuMeasurementStatuses.GOOD]: 'good',
		[AuMeasurementStatuses.NORMAL]: 'normal',
		[AuMeasurementStatuses.WARNING]: 'warning',
		[AuMeasurementStatuses.OK]: 'ok',
		[AuMeasurementStatuses.BAD]: 'bad',
		[AuMeasurementStatuses.POOR]: 'poor',
		[AuMeasurementStatuses.CRITICAL]: 'critical',
		[AuMeasurementStatuses.NoData]: 'no_data',
	};

export enum SensorStatusesDescription {
	running = 'running',
	notRunning = 'not_running',
	online = 'online',
	offline = 'offline',
	all = 'all',
	any = 'any',
	inProgress = 'in_progress',
	planned = 'planned',
	noData = '-',
	analyzing = 'analyzing',
	noStatus = 'no_status',
	new = 'new',
}

export enum SystemRunStatuses {
	any = 'any',
	running = 'run',
	notRunning = 'not_run',
	noStatus = 'no_status',
	analyzing = 'analyzing',
}

export enum EnvironmentNames {
	local = 'local',
	stage = 'stage',
	pr = 'pr',
	qa = 'qa',
	prod = 'prod',
}

export enum AuthenticationBy {
	keycloak = 'keycloak',
	autility = 'autility',
}

export enum AVAILABLE_USER_ROLES {
	SUPER_ADMIN = 'superAdmin',
	ADMIN = 'admin',
	VIEWER = 'viewer',
}

export enum UserOrganizationTypes {
	admin = 'admin',
	propertyManager = 'property_manager',
	facilityManager = 'facility_manager',
	tenant = 'tenant',
	service = 'service',
}

export enum OrganizationTypes {
	admin = 'admin',
	propertyManager = 'propertyManager',
	facilityManager = 'facilityManager',
	tenant = 'tenant',
	service = 'service',
}
